import { render, staticRenderFns } from "./town.vue?vue&type=template&id=bfdd2d52&scoped=true&"
import script from "./town.vue?vue&type=script&lang=js&"
export * from "./town.vue?vue&type=script&lang=js&"
import style0 from "./town.vue?vue&type=style&index=0&id=bfdd2d52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd2d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfdd2d52')) {
      api.createRecord('bfdd2d52', component.options)
    } else {
      api.reload('bfdd2d52', component.options)
    }
    module.hot.accept("./town.vue?vue&type=template&id=bfdd2d52&scoped=true&", function () {
      api.rerender('bfdd2d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/town.vue"
export default component.exports